var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMontenegro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc4d",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd2e44",
    d: "M3 3h24v18H3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc4d",
    d: "M20.77 10.9c.7-2.76-1.55-5.2-1.55-5.2l-.58 2.86-1.21 1.59.5.9-.5.27-1.19-1.65.44-1 1.53-.78-1.69-.56-1.02 1.2-.32 1.31-.39-1.32-1.1-1.19-1.6.36 1.34.9.53 1.08-1.1 1.7-.59-.33.5-.9-1.2-1.58-.59-2.86s-2.24 2.44-1.55 5.2c.7 2.75 3.66 3.14 3.66 3.14l-1.89 1.28-1.1.09-.2 1.21 1.01.47.88-.97 2.2-.8-1.26 1.82 2.45 1.3 2.37-1.3-1.22-1.72v-.08l2.1.78.88.97 1-.47-.2-1.21-1.1-.09-1.9-1.28s2.97-.39 3.66-3.14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c913b",
    d: "M15.18 13.3v1.48s-.2-.3-.85-.5c-.86-.25-1-.98-1-.98zm0 0v1.48s.21-.3.86-.5c.86-.25 1-.98 1-.98z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#269",
    d: "M13.73 10.2s.84.34 1.45.04v2.91h-1.86s-.07-.62.18-1.44c.16-.52-.14-.93-.14-.93zm2.9 0s-.84.34-1.44.04v2.91h1.86s.07-.62-.18-1.44c-.16-.52.14-.93.14-.93zM21 15.21a.91.91 0 1 1-1.83.07.91.91 0 0 1 1.83-.07"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc4d",
    d: "M16.36 7.03c0 .25-.5.45-1.11.45s-1.12-.2-1.12-.45.5-.46 1.12-.46c.61 0 1.11.2 1.11.46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc4d",
    d: "M15.22 5c-.97 0-1.75.45-1.75 1.01s.78 1.01 1.75 1.01 1.75-.45 1.75-1c0-.57-.78-1.02-1.75-1.02m-1.23 1.43c-.22-.09-.22-.34-.18-.52.03-.18.34-.36.34-.36s-.21.44-.04.62c.18.19.1.36-.12.26m.73-.01c-.07-.02-.08-.11-.13-.26-.05-.14-.1-.25-.07-.43.04-.18.48-.33.48-.33s-.12.37-.09.55c.04.17.18.36.18.36s-.29.13-.37.1m1.11-.26c-.05.15-.06.24-.13.26s-.37-.1-.37-.1.14-.2.18-.37a2 2 0 0 0-.1-.54s.45.15.49.32-.02.29-.07.43m.6.27c-.2.1-.3-.07-.12-.26.17-.18-.04-.62-.04-.62s.3.18.34.36.04.43-.17.52M21 15.31a.23.23 0 0 1-.28.17l-1.26-.33a.24.24 0 0 1-.17-.28.23.23 0 0 1 .28-.17l1.26.33a.23.23 0 0 1 .17.28"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc4d",
    d: "M20.33 15.16a.2.2 0 0 1-.25.15.2.2 0 0 1-.15-.25l.28-1.3a.2.2 0 0 1 .17-.15.2.2 0 0 1 .16.04.2.2 0 0 1 .07.22zm-8.77 3.14c-.07.03-.19-.11-.27-.31l-2.22-5.66c-.08-.2-.1-.39-.02-.42l.1-.04c.08-.03.37.05.45.25l2.22 5.66c.08.2-.08.45-.15.48zm2.69-6.44h1.87v1.3h-1.87z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMontenegro);
export default __webpack_public_path__ + "static/media/montenegro.3e4b016a4c89b4f46de2db3adb299a5e.svg";
export { ForwardRef as ReactComponent };